import { Popup, Table } from 'semantic-ui-react';
import { QUALITY_METRICS } from '../../utils/qualityBreakdown';
import type { QualityBreakdown } from '../../utils/qualityBreakdown';
import { getQualityMetricDetails } from '../../utils/qualityMetricDetails';
import './qualityScore.css';

type QualityScoreProps = {
    score: number | undefined;
    scope: number;
    breakdown: QualityBreakdown;
    /** Breakdown of the weighted-average row for the same category. When given, a "vs Avg" column is shown. */
    averageBreakdown?: QualityBreakdown;
    className?: string;
};

export default function QualityScore({ score, scope, breakdown, averageBreakdown, className }: QualityScoreProps) {
    const NAclass = score === undefined ? 'pale' : '';

    return <Popup
        size='small'
        wide='very'
        on='click'
        content={<>
            <div>Cells Scope: {scope}</div>
            <Table compact celled size='small'>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Metric</Table.HeaderCell>
                        <Table.HeaderCell>Total</Table.HeaderCell>
                        <Table.HeaderCell>Per 100</Table.HeaderCell>
                        <Table.HeaderCell>Contrib</Table.HeaderCell>
                        {averageBreakdown && <Table.HeaderCell>vs Avg</Table.HeaderCell>}
                    </Table.Row>
                </Table.Header>
                <Table.Body>
                    {QUALITY_METRICS.map(({ key, label }) => {
                        const details = getQualityMetricDetails(breakdown, key, averageBreakdown);
                        return <Table.Row key={key}>
                            <Table.Cell>{label}</Table.Cell>
                            <Table.Cell textAlign='right'>{details.total}</Table.Cell>
                            <Table.Cell textAlign='right'>{details.per100}</Table.Cell>
                            <Table.Cell textAlign='right'>{details.contribution}</Table.Cell>
                            {averageBreakdown && <Table.Cell textAlign='right' className={details.vsAverageClass}>{details.vsAverage}</Table.Cell>}
                        </Table.Row>;
                    })}
                </Table.Body>
            </Table>
        </>}
        trigger={<div
            className={`quality-score__trigger cursorPointer ${NAclass} ${className || ''}`}
        >{Number(score ?? 0).toFixed(2)}</div>}
    />;
}
